__turbopack_context__.v({
  "banner": "styles-module__NLChmW__banner",
  "buttonContainer": "styles-module__NLChmW__buttonContainer",
  "desc": "styles-module__NLChmW__desc",
  "description": "styles-module__NLChmW__description",
  "image": "styles-module__NLChmW__image",
  "title": "styles-module__NLChmW__title",
  "wrapper": "styles-module__NLChmW__wrapper",
});
